import Router from 'next/router'
import { useApolloClient } from '@apollo/client/react'
import { logEvent, resetTracking } from 'lib/tracking/segment'
import { RouterPage } from 'lib/navigation/consts'
import { useNavatticTourStore } from 'routes/[businessId]/hooks/useNavatticTour/useNavatticTour'
import * as events from './useLogout.events'

export const useLogout = () => {
  const client = useApolloClient()
  const clearUntilLoginNavatticDismissals = useNavatticTourStore((store) => store.clearLoginDismissals)

  return () => {
    logEvent(events.SIGNED_OUT)
    resetTracking()
    // Login-scoped tour dismissals must not survive a re-login — the floating widget shows again next session.
    clearUntilLoginNavatticDismissals()
    client.stop()
    client.clearStore()
    return Router.push(RouterPage.login)
  }
}
